import React from "react";
import "./FilterModal.scss";
import {
  Headline3,
  Label2,
  ButtonRound,
  Icon,
  Select,
} from "@bms-ai/bms-ai-ui-lib/components";
import type {
  BrandsResponse,
  ChannelsResponse,
} from "../../api/data-services/dashboard-api";
import { DateRangePicker } from "../DateRangePicker";

interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApplyFilters: (filters: FilterState) => void;
  brands: BrandsResponse | null;
  channels: ChannelsResponse | null;
  filters: FilterState;
  setFilters: React.Dispatch<React.SetStateAction<FilterState>>;
}

export interface FilterState {
  status: string;
  brand: string;
  channel: string;
  contrast: number;
  searchTaskId: string;
  sortBy: string;
  dateRange?: {
    startDate: Date | null;
    endDate: Date | null;
  };
}

const FilterModal: React.FC<FilterModalProps> = ({
  isOpen,
  onClose,
  onApplyFilters,
  brands,
  channels,
  filters,
  setFilters,
}) => {
  const handleApply = () => {
    onApplyFilters(filters);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="filter-modal-overlay" onClick={onClose}></div>
      <div className="filter-modal">
        <div className="filter-modal-header">
          <Headline3>Filters</Headline3>
          <button className="close-btn" onClick={onClose}>
            <Icon type="close" size="small" />
          </button>
        </div>

        <div className="filter-modal-body">
          <div className="filter-field">
            <Label2>Brand</Label2>
            <Select
              className="select-dropdown"
              options={
                brands?.brands.map((brand) => ({
                  label: brand.brand_name,
                  value: brand.brand_name,
                })) || []
              }
              preSelectedOption={
                filters.brand
                  ? { label: filters.brand, value: filters.brand }
                  : { label: "Select a brand", value: "" }
              }
              onSelect={(option) =>
                setFilters({ ...filters, brand: option?.value ?? "" })
              }
            />
          </div>

          <div className="filter-field">
            <Label2>Channel</Label2>
            <Select
              className="select-dropdown"
              options={
                channels?.channels.map((channel) => ({
                  label: channel.channel_name,
                  value: channel.channel_name,
                })) || []
              }
              preSelectedOption={
                filters.channel
                  ? { label: filters.channel, value: filters.channel }
                  : { label: "Select a channel", value: "" }
              }
              onSelect={(option) =>
                setFilters({ ...filters, channel: option?.value ?? "" })
              }
            />
          </div>

          <div className="filter-field">
            <Label2>Date Range</Label2>
            <DateRangePicker
              startDate={filters.dateRange?.startDate || null}
              endDate={filters.dateRange?.endDate || null}
              onChange={(startDate: Date | null, endDate: Date | null) =>
                setFilters({ ...filters, dateRange: { startDate, endDate } })
              }
            />
          </div>
        </div>

        <div className="filter-modal-footer">
          <ButtonRound onClick={handleApply}>
            Apply filters
          </ButtonRound>
        </div>
      </div>
    </>
  );
};

export default FilterModal;
